/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

export const IconAddHE = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
    <g>
      <circle className="fill-color-profile-accent" cx="28" cy="28" r="27.5"/>
      <path className="fill-color-profile-highlight" d="M28,1A27,27,0,1,1,1,28,27,27,0,0,1,28,1m0-1A28,28,0,1,0,56,28,28,28,0,0,0,28,0Z"/>
      <polygon
        fill="#fff"
        points="37 27 29 27 29 19 27 19 27 27 19 27 19 29 27 29 27 37 29 37 29 29 37 29 37 27"
      />
    </g>
  </svg>
);

export const IconAddNote = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
    <g id="icon-add-note">
      <circle className="fill-color-profile-accent" cx="28" cy="28" r="27.5"/>
      <path className="fill-color-profile-highlight" d="M28,1A27,27,0,1,1,1,28,27,27,0,0,1,28,1m0-1A28,28,0,1,0,56,28,28,28,0,0,0,28,0Z"/>

      <path
        fill="none"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M22.31,37,33.94,25.37a.4.4,0,0,0,0-.57L31.2,22.06a.4.4,0,0,0-.57,0L19,33.69a1.23,1.23,0,0,0-.36.79l-.23,3.11,3.11-.23A1.23,1.23,0,0,0,22.31,37Z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M34.38,18.31a1.07,1.07,0,0,1,1.5,0l1.81,1.81a1.07,1.07,0,0,1,0,1.5l-1.6,1.6-3.31-3.31Z"
      />
    </g>
  </svg>
);

export const IconAddFile = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
    <g id="icon-add-upload">
      <circle className="fill-color-profile-accent" cx="28" cy="28" r="27.5"/>
      <path className="fill-color-profile-highlight" d="M28,1A27,27,0,1,1,1,28,27,27,0,0,1,28,1m0-1A28,28,0,1,0,56,28,28,28,0,0,0,28,0Z"/>
      <path
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        d="M35.62,28l-6.84-6.69a1,1,0,0,0-1.43,0L20.5,28a1,1,0,0,0,.72,1.68h2.32a.25.25,0,0,1,.25.25v6.82a1,1,0,0,0,1,1h6.53a1,1,0,0,0,1-1V29.91a.26.26,0,0,1,.26-.25h2.32A1,1,0,0,0,35.62,28Z"
      />
      <line
        fill="none"
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        strokeLinecap="round"
        x1="20.06"
        y1="18"
        x2="36.06"
        y2="18"
      />
    </g>
  </svg>
);